// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer__root--Lmrn {
    width: 100%;
    padding: 32px 24px;
    background-color: var(--main-color);
    border-top: 1px solid var(--tertiary-color);
}

.Footer__wrapper--YUYg {
    max-width: 600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.Footer__address--g0Po {
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    text-align: center;
    color: var(--tertiary-color);
}

.Footer__information--SElj {
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    text-align: center;
    color: var(--tertiary-color);
    text-transform: uppercase;
}

.Footer__links--bnTE {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
}

.Footer__link--_eSx {
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    text-align: center;
    text-decoration: underline;
    color: var(--tertiary-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;AAChC","sourcesContent":[".root {\n    width: 100%;\n    padding: 32px 24px;\n    background-color: var(--main-color);\n    border-top: 1px solid var(--tertiary-color);\n}\n\n.wrapper {\n    max-width: 600px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.address {\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 400;\n    text-align: center;\n    color: var(--tertiary-color);\n}\n\n.information {\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 400;\n    text-align: center;\n    color: var(--tertiary-color);\n    text-transform: uppercase;\n}\n\n.links {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 16px;\n}\n\n.link {\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 400;\n    text-align: center;\n    text-decoration: underline;\n    color: var(--tertiary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Footer__root--Lmrn`,
	"wrapper": `Footer__wrapper--YUYg`,
	"address": `Footer__address--g0Po`,
	"information": `Footer__information--SElj`,
	"links": `Footer__links--bnTE`,
	"link": `Footer__link--_eSx`
};
export default ___CSS_LOADER_EXPORT___;
